import Axios, {AxiosResponse} from "axios";
import {IEmailDto} from "../models/email";
import RootApi from "./root-api";

export default class EmailApi extends RootApi {
    private readonly apiEndpoint: string = `${this.ApiRoot}/email`;

    public async sendEmail(request: IEmailDto): Promise<AxiosResponse> {
        return await Axios.post(this.apiEndpoint, request);
    }
}



// WEBPACK FOOTER //
// ./src/api/email-api.ts